import DTBackend from "@/services/DTBackend"
import Image from "@/services/Image"
import Helper from "@/services/Helper"

export class WishItemPresenter {
    constructor(item) {
        this.item = item || {};
    }

    get id() {
        return this.item?.wish_id ?? null;
    }

    get currencyAlias() {
        return this.item?.currency_alias ?? '';
    }

    get wishBudget() {
        const amount = Number(this.item?.wish_amount)
        return isNaN(amount) ? 0 : Helper.formatMoney(amount, 2, ".", " ")
    }

    get privacyText() {
        return this.item?.is_private ? 'Приватный' : 'Публичный';
    }

    get cntWishlists() {
        return this.item?.cnt_wishlists ?? 0;
    }

    get wishName() {
        return this.item?.wish_name ?? 'Без названия';
    }

    get wishDesc() {
        return this.item?.wish_desc ?? 'Описание отсутствует';
    }

    get formattedCreatedDate() {
        if (!this.item?.wish_created) return '';

        let dt = new DTBackend(this.item.wish_created).correctTZGet()
        return dt.get("%D.%M.%y <span>%H:%I</span>")
    }

    get isNotModerate() {
        let res = this.item?.is_moderate ?? null

        if (res === null) {
            return false
        }

        return res !== true
    }

    image(w, h) {
        let host = this.item?.wish_image_host ?? null
        let name = this.item?.wish_image_name ?? null

        if (host && name) {
            return Image.handle(host, name, w, h)
        }

        return "/assets/static/post/no_image.jpg"
    }

    get categoryName() {
        return this.item?.category_name ?? '';
    }

    hasCategory() {
        return this.categoryName !== ""
    }

    hasWishBudget() {
        let amount = Number(this.item?.wish_amount)
        return amount !== 0
    }

    hasCurrency() {
        return this.currencyAlias !== ""
    }

    hasCntWishlists() {
        return this.cntWishlists !== 0
    }

    get getUser() {
        return this.item.user ?? {}
    }

    get userName() {
        return this.getUser?.user_name ?? ""
    }

    userAvatar(w, h) {
        let host = this.getUser?.user_avatar_host ?? null
        let name = this.getUser?.user_avatar_name ?? null

        if (host && name) {
            return Image.handle(host, name, w, h)
        }

        return "/assets/static/user/no_image.jpg"
    }

    hasUser() {
        return !Helper.isEmptyObject(this.getUser)
    }
}
